const EmailStore = {
  default_email: 'support@sanne.com',
};

export default EmailStore;